module.exports = __webpack_public_path__ + "static/media/loader.bf3ffc25.svg";